import moment from 'moment'

export const setSaleDate = (initialDate: string | undefined, amountDays: number | undefined) => {
  if (initialDate === undefined || amountDays === undefined) return ''
  return moment(initialDate).add(amountDays, 'days').toDate()
}
